module.exports = __webpack_public_path__ + "media/images/design/test-20f45594ced663679098a05b24b52ce8.jpg";